module.exports = __webpack_public_path__ + "static/media/gaming.1e536f43.png";